import { Block } from '../../factories/types';
import { RichText } from '../../utils/rich-text/RichText';

export const TextBlock: Block<'textBlock', object> = ({
	data: {
		fields: { text },
	},
	fieldId,
	context: props = {}
}) =>
	<span {...fieldId('text')} {...props}>
		<RichText document={text} />
	</span>
